import type { EventTracker } from './events/event-manager.ts'
import { ensureError } from './utils/ensure-error.ts'
import { type Logger, TaggedLogger } from './logging/logger.ts'

enum StaticEventDispatchType {
    ERROR = 1,
}

/** @internal */
export class StaticEventDispatcher {
    protected static eventManager: EventTracker | undefined

    private static logger: Logger

    static {
        this.logger = TaggedLogger._getInstance('Dispatch')
    }

    public static EventType = StaticEventDispatchType

    public static _setEventManager(eventManager: EventTracker) {
        this.eventManager = eventManager
    }

    public static _dispatch(dispatchType: StaticEventDispatchType, payload: unknown): void {
        try {
            if (!this.eventManager) {
                this.logger.verbose('Received', payload)
                return
            }

            switch (dispatchType) {
                case StaticEventDispatchType.ERROR: {
                    this.logger.verbose('Received', payload)
                    // this.eventManager._track(ensureError(payload))
                    break
                }
            }
        } catch (err) {
            this.logger.warn(ensureError(err))
        }
    }
}
